import { createContext, useContext, useEffect, useState } from 'react';
import { api } from './api';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const raw = localStorage.getItem('startin_user');
      return raw ? JSON.parse(raw) : null;
    } catch { return null; }
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('startin_token');
    if (token) {
      api.get('/auth/me').then((r) => {
        setUser(r.data);
        localStorage.setItem('startin_user', JSON.stringify(r.data));
      }).catch(() => {});
    }
  // eslint-disable-next-line
  }, []);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const r = await api.post('/auth/login', { email, password });
      localStorage.setItem('startin_token', r.data.token);
      localStorage.setItem('startin_user', JSON.stringify(r.data.user));
      setUser(r.data.user);
      return r.data.user;
    } finally { setLoading(false); }
  };

  const register = async (payload) => {
    setLoading(true);
    try {
      const r = await api.post('/auth/register', payload);
      localStorage.setItem('startin_token', r.data.token);
      localStorage.setItem('startin_user', JSON.stringify(r.data.user));
      setUser(r.data.user);
      return r.data.user;
    } finally { setLoading(false); }
  };

  const logout = () => {
    localStorage.removeItem('startin_token');
    localStorage.removeItem('startin_user');
    setUser(null);
    window.location.href = '/auth';
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
